var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1414",
    "data-name": "Group 1414",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.16,
    height: 13.918,
    viewBox: "0 0 15.16 13.918",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_441",
    "data-name": "Rectangle 441",
    width: 15.16,
    height: 13.918,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1413",
    "data-name": "Group 1413",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M.006,116.771l1.531-5.114.068-.1v4.572a2.466,2.466,0,0,0,2.411,2.088h9.1l-.645,2.062a1.456,1.456,0,0,1-1.552.771L1.16,118.443a1.54,1.54,0,0,1-1.154-1.169c-.02-.155.014-.344,0-.5",
    transform: "translate(0 -107.151)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M65.271.01,74.882,0a1.615,1.615,0,0,1,1.554,1.406V8.718a1.589,1.589,0,0,1-1.406,1.406H65.2a1.617,1.617,0,0,1-1.4-1.437V1.467A1.609,1.609,0,0,1,65.271.01m9.891,6.029V1.525c0-.063-.162-.236-.25-.223l-9.636.014a.38.38,0,0,0-.206.268V7.518c.656-.6,1.239-1.281,1.914-1.86.967-.582,1.543.323,2.156.912.838-1,1.645-2.023,2.516-2.988a1.144,1.144,0,0,1,1.6.236Z",
    transform: "translate(-61.276)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M114.215,49.411a1.274,1.274,0,1,1-1.274-1.274,1.274,1.274,0,0,1,1.274,1.274",
    transform: "translate(-107.252 -46.234)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLibrary);
export default __webpack_public_path__ + "static/media/imageLibrary.6a3e666c756d40d0f93a2597b45198d4.svg";
export { ForwardRef as ReactComponent };